export default __webpack_public_path__ + "static/media/reference-impreso-establecimiento.370810a7.svg";